import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as api from "../../redux/api";
import { Country } from "country-state-city";
import Loader from "../../components/loaders/Loader";
import { reactIcons } from "../../utils/icons";
import { useNavigate, useParams } from "react-router-dom";
import EntityFormlog from "../../components/Forms/EntityFormlog";
import CustomFileInput from "../../components/CustomFileInput";
import BackButton from "../../components/BackButton";

const initialState = {
  type: "",
  name: "",
  RegistrationNumber: "",
  emailAddress: "",
  phoneNumber: "",
  website: "",
  address: "",
  dateOfIncorporation: null,
  logisticsPrimaryTransportMethods: [],
  logisticsAreasOfOperation: [],
  efficiencyMetrics: "",
  certification1: "",
  certification2: "",
  ol: [],
  ecl: [],
  logisticsThirdPartyCarriers: ""
};

const AddLogistics = () => {
  const [step1, setStep1] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState({});
  const [dialCode, setDialCode] = useState("91");
  const [selectedCountry, setSelectedCountry] = useState("IN");
  const [countryName, setCountryName] = useState("India");

  const [apiData, setApiData] = useState({});
  const [isReadOnly, setIsReadOnly] = useState(false);
  const transportOptions = ["Air", "Ground", "Sea"];
  const coverageOptions = ["Regional", "National", "International"];
  const { id } = useParams();

  const navigate = useNavigate();

  const getData = async () => {
    try {
      if (!id) return;
      const res = await api.getUserList(id);

      if (res?.status && res?.data?.data) {
        const userData = res.data.data;
        setApiData(res.data);

        const OrganizationMeta = userData.OrganizationMeta?.[0] || {};
        setIsReadOnly(true);

        setForm((prev) => ({
          ...prev,
          type: userData.type || "",
          name: userData.name || "",
          RegistrationNumber: userData.registrationNumber || "",
          emailAddress: userData.emailAddress || "",
          phoneNumber: userData.phoneNumber?.replace(/^\+91/, "") || "",
          website: userData.website || "",
          address: userData.address || "",
          dateOfIncorporation: userData.dateOfIncorporation
            ? new Date(userData.dateOfIncorporation)
            : null,
          logisticsPrimaryTransportMethods:
            OrganizationMeta.logisticsPrimaryTransportMethods || "",
          logisticsThirdPartyCarriers:
            OrganizationMeta.logisticsThirdPartyCarriers?.[0] || "",
          logisticsAreasOfOperation:
            OrganizationMeta.logisticsAreasOfOperation || "",
          ol: (OrganizationMeta.logisticsProofOfInsurancePolicy || []).map(
            (url) => ({
              name: url.split("/").pop(),
              url
            })
          ),
          ecl: (OrganizationMeta.logisticsVehicleFleetRegistration || []).map(
            (url) => ({
              name: url.split("/").pop(),
              url
            })
          )
        }));
      } else {
        console.error("Error fetching data:", res?.message || "Unknown error");
      }
    } catch (error) {
      console.error("API Error:", error?.message || error);
    }
  };

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);
  console.log("logisctic", form);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
    setFormError({
      ...formError,
      [name]: ""
    });
  };

  const handleStepComplete = (stepData) => {
    setForm({
      ...form,
      ...stepData
    });
    setStep1(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    let errors = {};
    if (!form.logisticsPrimaryTransportMethods?.length) {
      errors.logisticsPrimaryTransportMethods =
        "Select at least one transport method";
    }

    if (!form.logisticsAreasOfOperation?.length) {
      errors.logisticsAreasOfOperation = "Select at least one coverage area";
    }

    if (!form.ol?.length) {
      errors.ol = "Please upload at least one insurance policy document";
    }

    if (!form.ecl?.length) {
      errors.ecl = "Please upload at least one registration document";
    }
    if (Object.keys(errors).length) {
      setFormError(errors);
      return;
    }
    try {
      setIsLoading(true);

      const payload = {
        type: form.type,
        primaryContactName: form.primaryContactName,
        name: form.name,
        registrationNumber: form.RegistrationNumber,
        emailAddress: form.emailAddress,
        phoneNumber: `+${dialCode}${form.phoneNumber}`,
        website: form.website || "",
        address: form.address,
        dateOfIncorporation: form.dateOfIncorporation,
        dialCode: "+" + dialCode,
        country: countryName,
        countryOfIncorporation: form.countryOfIncorporation,
        logisticsPrimaryTransportMethods: [
          form.logisticsPrimaryTransportMethods
        ],
        logisticsThirdPartyCarriers: [form.logisticsThirdPartyCarriers],
        logisticsAreasOfOperation: form.logisticsAreasOfOperation,
        efficiencyMetrics: [form.efficiencyMetrics] || "",
        documentationChecklist: {},
        beneficialOwners: [],
        complianceRiskAssessment: [],
        addedBy: "admin",
        organizationMeta: [
          {
            logisticsPrimaryTransportMethods:
              form.logisticsPrimaryTransportMethods,
            logisticsThirdPartyCarriers: [form.logisticsThirdPartyCarriers],
            logisticsAreasOfOperation: form.logisticsAreasOfOperation,
            logisticsProofOfInsurancePolicy: form.ol.map((doc) => doc.url),
            logisticsVehicleFleetRegistration: form.ecl.map((doc) => doc.url)
          }
        ]
      };

      const res = await api.registerUser(payload);
      if (res.status === 200 || res.status === 201) {
        localStorage.removeItem("organizationId");

        toast.success("Logistics Added Successfully");
        navigate(`/documentation-checklist/${res.data.id}`, {
          state: { key: "saurabh" }
        });
        localStorage.setItem("organizationId", res.data.id);
      } else {
        toast.error(res?.error?.message);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        Array.isArray(error.response.data.message)
      ) {
        toast.error(error.response.data.message[0]);
      } else if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while submitting the form");
      }
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    setSelectedCountry(countryCode);
    const country = Country.getAllCountries().find(
      (c) => c.isoCode === countryCode
    );
    setCountryName(country.name);
    setDialCode(country?.phonecode);
  };

  useEffect(() => {
    const country = Country.getAllCountries().find((c) => c.isoCode === "IN");
    if (country) {
      setCountryName(country.name);
    }
  }, []);
  const handleTransportSelect = (method) => {
    setForm((prev) => {
      const arr = prev.logisticsPrimaryTransportMethods || [];
      const next = arr.includes(method)
        ? arr.filter((m) => m !== method)
        : [...arr, method];
      return {
        ...prev,
        logisticsPrimaryTransportMethods: next
      };
    });
    setFormError((prev) => ({
      ...prev,
      logisticsPrimaryTransportMethods: ""
    }));
  };
  const handleCoverageSelect = (scope) => {
    setForm((prev) => {
      const arr = prev.logisticsAreasOfOperation || [];
      const next = arr.includes(scope)
        ? arr.filter((s) => s !== scope)
        : [...arr, scope];
      return { ...prev, logisticsAreasOfOperation: next };
    });
    setFormError((prev) => ({
      ...prev,
      logisticsAreasOfOperation: ""
    }));
  };

  return (
    <div>
      <header className="flex items-center gap-2">
        <BackButton />
        <h4 className="">Add Logistics</h4>
      </header>
      <div className="border mt-5 border-yellow-dark p-5  rounded-[10px]">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (id) {
              navigate(`/documentation-checklist/${id}`);
            } else {
              handleSubmit(e);
            }
          }}
        >
          <div className="relative">
            {!step1 ? (
              <div className="font-semibold text-black text-20">
                Organization Information
              </div>
            ) : (
              <div className="font-semibold text-20 text-black">
                For Logistics Providers
              </div>
            )}
            {!step1 ? (
              <EntityFormlog
                handleChange={handleChange}
                formError={formError}
                handleCountryChange={handleCountryChange}
                selectedCountry={selectedCountry}
                Country={Country}
                dialCode={dialCode}
                onStepComplete={handleStepComplete}
                form={apiData?.data}
                isReadOnly={isReadOnly}
              />
            ) : (
              <div className="lg:grid grid-cols-1 sm:grid-cols-2  gap-6 items-start mt-4">
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block text-black">
                    Primary transportation methods
                    <span className="text-red-600">*</span>
                  </label>
                  <div className="flex gap-3 flex-wrap">
                    {transportOptions.map((opt) => {
                      const selected =
                        form.logisticsPrimaryTransportMethods?.includes(opt);
                      return (
                        <button
                          key={opt}
                          type="button"
                          onClick={() => handleTransportSelect(opt)}
                          disabled={isReadOnly}
                          className={`
          px-4 py-2 rounded-md border
          ${
            selected
              ? "bg-yellow-700 text-white border-yellow-700"
              : "bg-white text-black border-gray-300"
          }
          ${
            isReadOnly
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-yellow-100 hover:text-black"
          }
        `}
                        >
                          {opt}
                        </button>
                      );
                    })}
                  </div>
                  {formError.logisticsPrimaryTransportMethods && (
                    <div className="form-eror">
                      {formError.logisticsPrimaryTransportMethods}
                    </div>
                  )}
                </div>

                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block text-black">
                    Geographic coverage<span className="text-red-600">*</span>
                  </label>

                  <div className="flex gap-3 flex-wrap">
                    {coverageOptions.map((opt) => {
                      const selected =
                        form.logisticsAreasOfOperation.includes(opt);
                      return (
                        <button
                          key={opt}
                          type="button"
                          onClick={() => handleCoverageSelect(opt)}
                          disabled={isReadOnly}
                          className={`
          px-4 py-2 rounded-md border
          ${
            selected
              ? "bg-yellow-700 text-white border-yellow-700"
              : "bg-white text-black border-gray-300"
          }
          ${
            isReadOnly
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-yellow-100 hover:text-black"
          }
        `}
                        >
                          {opt}
                        </button>
                      );
                    })}
                  </div>
                  {formError.logisticsAreasOfOperation && (
                    <div className="form-eror">
                      {formError.logisticsAreasOfOperation}
                    </div>
                  )}
                </div>
                <div className="mb-3 mt-6 lg:mb-0">
                  <label className="mb-2 block text-black">
                    Third-party carriers (if applicable)
                  </label>
                  <input
                    type="text"
                    placeholder="Enter carriers"
                    autoComplete="off"
                    name="logisticsThirdPartyCarriers"
                    onChange={handleChange}
                    // className="text-input text-black text-12 lg:text-14 border"
                    value={form.logisticsThirdPartyCarriers}
                    readOnly={isReadOnly}
                    className={`text-input ${
                      isReadOnly ? "readonly-input" : ""
                    }`}
                  />
                </div>

                <div>
                  <CustomFileInput
                    label="Fleet insurance policy"
                    allowedFormats=" PDF"
                    name="ol"
                    defaultValue={form.ol.map((f) => f.url)}
                    disabled={isReadOnly}
                    onChange={(urls) => {
                      const files = urls.map((url) => ({
                        name: url.split("/").pop(),
                        url
                      }));
                      setForm((prev) => ({ ...prev, ol: files }));
                      setFormError((prev) => ({ ...prev, ol: "" })); // ← clear the error
                    }}
                  />
                  {formError.ol && (
                    <div className="form-eror">{formError.ol}</div>
                  )}
                </div>
                <div className="-mt-14">
                  <CustomFileInput
                    label="Registration document(s)"
                    allowedFormats=" PDF"
                    name="ecl"
                    defaultValue={form.ecl.map((f) => f.url)}
                    disabled={isReadOnly}
                    onChange={(urls) => {
                      const files = urls.map((url) => ({
                        name: url.split("/").pop(),
                        url
                      }));
                      setForm((prev) => ({ ...prev, ecl: files }));
                      setFormError((prev) => ({ ...prev, ecl: "" })); // ← clear the error
                    }}
                  />
                  {formError.ecl && (
                    <div className="form-eror">{formError.ecl}</div>
                  )}
                </div>
              </div>
            )}
          </div>
          {!step1 ? (
            <div className="flex gap-2 mt-5 justify-end items-center">
              {/* Step 2 button is now inside the EntityForm component */}
            </div>
          ) : (
            <div className="flex gap-2 mt-5 justify-end items-center">
              <button
                type="button"
                onClick={() => setStep1(false)}
                className={`btn btn-danger `}
              >
                {reactIcons.arrowleft} Back
              </button>
              <button
                type="submit"
                // disabled={isLoading || !form.logisticsPrimaryTransportMethods}
                className={`btn btn-primary ${
                  isLoading || !form.logisticsPrimaryTransportMethods
                    ? "bg-red-500 border-red-500 opacity-50 disabled:pointer-events-none"
                    : undefined
                }`}
              >
                {isLoading ? <Loader /> : "Next"}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddLogistics;
